import React from 'react'
import ProdIOOOutExoRow from './ProdIOOOutExoRow'
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOOutExo = (props) => {
    const { formObject, viewData, ...restProps } = props;

    const rowSelector = useRowSelector("2", null);

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, 
            actionParam: { selected: rowSelector.getSelectedRowsCS(), pathKey: "OOUT"} }}
            contentStyle={{ height: '300px' }}
            formStyle={{ width: '750px', height: '400px' }} formTitle={<SarasTrans value="Add Actual Output" />}
        >
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Required Qty" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Already Output Qty" /></li>
                                <li className="uiColumnCenter uiColumn130"><SarasTrans value="Output Quantity" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOOutExoRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index}  index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(ProdIOOOutExo, "prodIOAddOOUT", "prodIOOOUT,prodIOEOGroup");